/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import LayoutFiveColumnsIcon from '@atlaskit/icon-lab/core/layout-five-columns';
import LayoutFourColumnsIcon from '@atlaskit/icon-lab/core/layout-four-columns';
var wrapperStyle = css({
  padding: '0 4px'
});
var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: wrapperStyle
  }, children);
};
export var EditorLayoutFiveColumnsIcon = function EditorLayoutFiveColumnsIcon() {
  return jsx(Wrapper, null, jsx(LayoutFiveColumnsIcon, {
    label: ""
  }));
};
export var EditorLayoutFourColumnsIcon = function EditorLayoutFourColumnsIcon() {
  return jsx(Wrapper, null, jsx(LayoutFourColumnsIcon, {
    label: ""
  }));
};